export const EMAIL_TEMPLATES = {
  CUSTOM: {
    label: 'Custom',
    subject: '',
    message: '',
  },
  ACIC_CANDIDATE: {
    label: 'ACIC Results Candidate',
    subject: 'ACIC Check Results',
    message: `<p>Dear Candidate,</p>
      <p>Please find attached your <strong>Nationally Coordinated Criminal History Check (NCCHC)</strong> as supplied by the <strong>Australian Criminal Intelligence Commission (ACIC)</strong>.</p>

      <p>As the Accredited Body, <strong>Checkmate Technology Pty Ltd</strong> is required to provide you with the check outcomes before releasing them to your prospective employer. Please read the result document carefully and check for any errors.</p>

      <p><strong>Important - Your Rights</strong></p>
      <ul>
        <li>As the subject of the check, you have a <strong>right to have any errors corrected</strong>. If you wish to dispute the outcome of this check, please reply to this email within <strong>48 hours of receipt</strong>, outlining the reasons that you wish to raise a dispute. One of our team will contact you for more information, and you will be asked to complete a form which we will send to the ACIC and relevant Police services. Your check results will <strong>not be released until the dispute has been resolved</strong>.</li>
        <li>If you choose not to respond, we will release the results as they stand once the <strong>48 hour period has elapsed</strong>.</li>
        <li>If you are <strong>happy with the results</strong>, you do not need to respond — we will release the results to your prospective employer after 48 hours have elapsed. Alternatively, you may provide consent for early release by replying to this email with the words <strong>'No Dispute'</strong>.</li>
        <li>If there are <strong>no disclosable court outcomes</strong> revealed in the check, we can also release the results <strong>immediately</strong> so that your recruitment process can continue.</li>
      </ul>

      <p>Please reply directly to this email if you have any questions or concerns. Your timely response will help ensure a smooth process.</p>

      <p>Thanks,</p>
      <p><strong>The Checkmate Team</strong></p>
      <br/>
      <p><strong>Need Help?</strong></p>
      <p><strong>Email us at <a href="mailto:national-criminal-checks-au@checkmate.tech">national-criminal-checks-au@checkmate.tech</a></strong></p>
      <p><strong>Checkmate – Smart Background Screening made easy</strong></p>`,
  },
};

export const SENDER_EMAILS = {
  ADMIN: process.env.REACT_APP_SUPPORT_EMAIL,
  CHECKS_SUPPORT: process.env.REACT_APP_CHECKS_SUPPORT_EMAIL,
  ACIC_SUPPORT: process.env.REACT_APP_ACIC_SUPPORT_EMAIL,
};
